<template>
  <!-- ============================================================== -->
  <!-- Topbar header - style you can find in pages.scss -->
  <!-- ============================================================== -->
  <header class="topbar">
    <!-- <VeinCheckInModal
        
        @close-modal="dropdownModalClosed(false)"
        ></VeinCheckInModal> -->
    <QuickCheckinInfo
      v-if="showDropDownModalInfo == true"
      :hideQuickCheckinInfo="hideQuickCheckinInfo"
      :pat="pat"
    >
    </QuickCheckinInfo>
    <QuickCheckinMain
      :showQuickCheckinInfo="showQuickCheckinInfo"
      :getPatientFromMain="getPatientFromMain"
      ref="quickCheckinMain"
      v-if="showDropDownModal == true"
      @close-modal="dropdownModalClosed(false)"
      @show-modal="showModal(groupId, groupColor)"
    ></QuickCheckinMain>
    <nav
      class="navbar top-navbar navbar-expand-md navbar-dark"
      v-bind:class="{ backgroundgray: isemployee }"
    >
      <!-- ============================================================== -->
      <!-- Logo -->
      <!-- ============================================================== -->
      <div class="navbar-header">
        <a class="navbar-brand" href="/dashboard">
          <!-- Logo icon --><b>
            <!--You can put here icon as well // <i class="wi wi-sunset"></i> //-->
            <!-- Dark Logo icon -->
          </b>
          <!--End Logo icon -->
          <!-- Logo text --><span>
            <!-- dark Logo text -->
            <img
              src="assets/images/rtplogo.png"
              style="height: 75px; margin-left: 35px"
              class="light-logo"
              alt="homepage"
          /></span>
        </a>
      </div>
      <!-- ============================================================== -->
      <!-- End Logo -->
      <!-- ============================================================== -->
      <div class="navbar-collapse">
        <!-- ============================================================== -->
        <!-- toggle and nav items -->
        <!-- ============================================================== -->
        <ul class="navbar-nav mr-auto">
          <!-- This is  -->
          <li class="nav-item">
            <a
              class="
                nav-link nav-toggler
                d-block d-md-none
                waves-effect waves-dark
              "
              href="javascript:void(0)"
              ><i class="ti-menu"></i
            ></a>
          </li>
          <li class="nav-item">
            <a
              class="
                nav-link
                sidebartoggler
                d-none d-lg-block d-md-block
                waves-effect waves-dark
              "
              href="javascript:void(0)"
              ><i class="icon-menu"></i
            ></a>
          </li>
          <li class="nav-item">
            <h1 class="dashboardName">{{ UserD_name }} Practice Dashboard</h1>
            <p class="boldText text-white">{{ Practice }}</p>
          </li>
          <!-- ============================================================== -->
        </ul>
        <!-- ============================================================== -->
        <!-- User profile and search -->
        <!-- ============================================================== -->
        <ul class="navbar-nav my-lg-0">
          <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle waves-effect waves-dark"
              @click="HomeButton()"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i
                class="fas fa-home"
                data-toggle="tooltip"
                data-placement="left"
                title=""
                data-original-title="User Dashboard"
              ></i>
              <div class="notify"></div>
            </a>
          </li>

          <!-- ============================================================== -->
          <!-- Comment -->
          <!-- ============================================================== -->
          <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle waves-effect waves-dark"
              href=""
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i
                class="fas fa-search-location"
                data-toggle="tooltip"
                data-placement="left"
                title=""
                data-original-title="My Locations"
              ></i>
              <div v-if="showNotify1 == 1" class="notify">
                <span class="heartbit"></span> <span class="point"></span>
              </div>
              <div v-else class="notify"></div>
            </a>
            <div
              class="
                dropdown-menu dropdown-menu-right
                mailbox
                animated
                bounceInDown
              "
            >
              <ul>
                <li>
                  <div class="drop-title">My Locations</div>
                </li>
                <li>
                  <div class="message-center">
                    <!-- Message -->
                    <a v-for="(prac, usrKey11) in Practices" :key="usrKey11">
                      <div
                        class="mail-contnet"
                        @click="goButtonClick(prac.practiceId)"
                      >
                        <div class="btn btn-danger btn-circle">
                          <i class="fa fa-link"></i>
                        </div>
                        <span class="mail-desc" id="notify1">
                          {{ prac.practiceName }}
                        </span>
                        <span class="time" id="notify2">
                          {{ prac.streetAddress }} <br />
                          {{ prac.phone }}
                        </span>
                      </div>
                    </a>
                  </div>
                </li>
                <li>
                  <a
                    @click="ViewAllLocationClick()"
                    class="nav-link text-center link"
                  >
                    <strong>View All Locations</strong>
                    <i class="fa fa-angle-right"></i>
                  </a>
                </li>
              </ul>
            </div>
          </li>
          <!-- ============================================================== -->
          <!-- End Comment -->
          <!-- ============================================================== -->
          <!-- ============================================================== -->
          <!-- Messages -->
          <!-- ============================================================== -->
          <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle waves-effect waves-dark"
              @click="GetUserNotifications()"
              href=""
              id="2"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i class="fas fa-bell"></i>
              <div v-if="showNotify == 1" class="notify">
                <span class="heartbit"></span> <span class="point"></span>
              </div>
              <div v-else class="notify"></div>
            </a>
            <div
              class="
                dropdown-menu
                mailbox
                dropdown-menu-right
                animated
                bounceInDown
              "
              aria-labelledby="2"
            >
              <ul>
                <li>
                  <div class="drop-title">
                    You have {{ seenCount }} new Notification
                  </div>
                </li>
                <li style="overflow:auto; max-height:500px">
                  <AuditLogComponent
                    ref="auditLogComponent"
                    :notificationOnly="true"
                  />
                </li>
                <li>
                  <router-link
                    class="nav-link text-center link"
                    to="/auditlogtimeline"
                  >
                    <strong>See all Notification</strong>
                    &nbsp;<i class="fa fa-angle-right"></i>
                  </router-link>
                </li>
              </ul>
            </div>
          </li>
          <!-- ============================================================== -->
          <!-- End Messages -->
          <!-- ============================================================== -->
          <!-- ============================================================== -->

          <li class="nav-item">
            <a
              class="nav-link waves-effect waves-dark"
              @click="newTabClick"
              aria-expanded="false"
            >
              <i
                class="fas fa-check"
                data-toggle="tooltip"
                data-placement="left"
                title=""
                data-original-title="Quick Check-in"
              ></i>
              <div class="notify"></div>
            </a>
          </li>

          <!-- ============================================================== -->
          <!-- ============================================================== -->
          <!-- User Profile -->
          <!-- ============================================================== -->
          <li class="nav-item dropdown u-pro">
            <a
              class="
                nav-link
                dropdown-toggle
                waves-effect waves-dark
                profile-pic
              "
              href=""
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <img
                v-if="Image == ''"
                src="assets/images/profile.jpg"
                alt="user"
                class=""
              />
              <img
                v-else
                :src="Image"
                alt=""
                class=""
                style="height: 30px; width: 30px"
              />
              <span class="hidden-md-down ml-2"
                >{{ name }} &nbsp;<i class="fa fa-angle-down"></i
              ></span>
            </a>

            <div class="dropdown-menu dropdown-menu-right animated flipInY">
              <!-- text-->
              <a
                href="javascript:void(0)"
                style="color:black;"
                class="dropdown-item"
                ><i class="ti-user"></i>
                <router-link to="/ProfilePage" style="color:black;">
                  My Profile
                </router-link></a
              >
              <!-- text-->
              <div class="dropdown-divider"></div>
              <!-- text-->
              <a
                href="javascript:void(0)"
                @click="logoutClick()"
                class="dropdown-item"
                ><i class="fa fa-power-off"></i> Logout</a
              >
              <!-- text-->
            </div>
          </li>

          <li class="nav-item">
            <a
              class="nav-link waves-effect waves-dark"
              @click="lockScreen()"
              href=""
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i
                class="fas fa-lock"
                data-toggle="tooltip"
                data-placement="left"
                title=""
                data-original-title="lockscreen"
              ></i>
              <div class="notify"></div>
            </a>
          </li>

          <!-- ============================================================== -->
          <!-- End User Profile -->
        </ul>
      </div>
    </nav>
  </header>
  <!-- ============================================================== -->
  <!-- End Topbar header -->
  <!-- ============================================================== -->
  <!-- My Profile -->
  <div
    id="myProfile"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
    aria-hidden="true"
    style="display: none"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">My Profile</h4>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-hidden="true"
          >
            ×
          </button>
        </div>
        <div class="modal-body">
          <form class="floating-labels">
            <div class="form-row">
              <div class="col-md-6">
                <!-- First Name -->
                <div class="form-floating-label">
                  <input
                    v-model="profileInfo.firstName"
                    name="firstname"
                    class="form-control"
                    id="firstname"
                    required=""
                    type="text"
                  />
                  <label for="firstName">First Name</label>
                </div>
                <!-- First Name -->
              </div>
              <div class="col-mb-6">
                <!-- Last Name -->
                <div class="form-floating-label">
                  <input
                    v-model="profileInfo.lastName"
                    name="lastName"
                    class="form-control"
                    id="lastName"
                    required=""
                    type="text"
                  />
                  <label for="lastName">Last Name</label>
                </div>
                <!-- Last Name -->
              </div>
            </div>

            <div class="row">
              <div class="col">
                <!-- Date -->
                <div class="form-group">
                  <input
                    v-model="profileInfo.doBstr"
                    type="date"
                    class="form-control"
                    name="date"
                    id="date"
                    placeholder="mm-dd-yyyy"
                    required=""
                  />
                </div>
                <!-- Date -->
              </div>
            </div>

            <div class="row">
              <div class="col">
                <!-- Email -->
                <div class="form-floating-label">
                  <input
                    disabled
                    v-model="profileInfo.email"
                    name="email"
                    class="form-control"
                    id="email"
                    required=""
                    type="email"
                  />
                  <label for="email">Email</label>
                </div>
                <!-- Email -->
              </div>
              <div class="col">
                <!-- phone -->
                <div class="form-floating-label">
                  <input
                    v-model="profileInfo.phone"
                    name="phone"
                    class="form-control"
                    id="phone"
                    required=""
                    type="tel"
                  />
                  <label for="phone">Phone Number</label>
                </div>
                <!-- phone -->
              </div>
            </div>

            <div class="row">
              <div class="col">
                <!-- password -->
                <div class="form-floating-label">
                  <input
                    v-model="profileInfo.password"
                    name="password"
                    class="form-control"
                    id="password"
                    required=""
                    type="password"
                  />
                  <label for="password">Password</label>
                </div>
                <!-- password -->
              </div>
              <div class="col">
                <!-- password -->
                <div class="form-floating-label">
                  <input
                    v-model="profileInfo.confirmPassword"
                    class="form-control"
                    id="password1"
                    required=""
                    type="password"
                  />
                  <label for="password">Confirm Password</label>
                </div>
                <!-- password -->
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-success waves-effect waves-light"
            @click="UpdateProfileInfo()"
          >
            Send
          </button>
          <button
            type="button"
            class="btn btn-danger waves-effect waves-light"
            data-dismiss="modal"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </div>

  <div
    class="modal fade"
    id="mngNotifications"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
    aria-hidden="true"
    style="display: none"
  >
    <div class="modal-dialog cascading-modal modal-lg">
      <div
        class="modal-content"
        style="width: 1330px !important; margin-left: -270px"
      >
        <div class="modal-header">
          <h4 class="modal-title" id="myLargeModalLabel">Notifications</h4>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-hidden="true"
          >
            ×
          </button>
        </div>
        <div class="modal-body mb-1 pt-2">
          <div class="card p-3">
            <div class="table-responsive">
              <table
                id="tablenotification"
                data-height="300"
                class="table display table-bordered table-striped no-wrap"
              >
                <thead class="thead-dark">
                  <tr>
                    <th>Name</th>
                    <th>Title</th>
                    <th>Message</th>
                    <th>Description</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="x in notifications" :key="x.notificationId">
                    <td>
                      {{ x.name }}
                    </td>
                    <td>
                      {{ x.title }}
                    </td>
                    <td>
                      {{ x.message }}
                    </td>
                    <td>
                      {{ x.description }}
                    </td>
                    <td>
                      {{ x.addDateStr }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- My Profile -->
</template>

<script>
import axios from "axios";
import moment from "moment";
import { mapGetters } from "vuex";
// import VeinCheckInModal from "../views/Patients/VeinCheckInModal.vue";
import QuickCheckinInfo from "../views/Patients/QuickCheckinInfo.vue";
import QuickCheckinMain from "../views/Patients/QuickCheckinMain.vue";
import AuditLogComponent from "../components/AuditLogComponent.vue";

export default {
  name: "UHeader",
  components: {
    QuickCheckinMain,
    QuickCheckinInfo,
    // VeinCheckInModal,
    AuditLogComponent,
  },
  computed: {
    Image12() {
      return this.getProfileImage;
    },
    ...mapGetters([
      "getProfileImage",
      "geterLocalStorage",
      "getLocalStoragexeon",
    ]),
  },
  data() {
    return {
      //name Dashboard
      UserD_name: "",

      //Checkin Modal
      pat: null,
      showDropDownModal: false,
      showDropDownModalInfo: false,
      value: localStorage.OSversion,
      Id1: localStorage.xeon,
      profileInfo: {},
      name: null,
      Id: null,
      ownerId: null,
      UserId: null,
      Practice: "No Practice",
      PracticeId: null,
      Practices: [],
      seenCount: null,
      seenCount1: null,
      Image: "",
      Image1: "",
      notification: [],
      notifications: {},
      notifications1: {},
      showNotify: 0,
      showNotify1: 0,
    };
  }, // end data

  methods: {
    showModal(groupId, groupColor) {
      debugger;
      this.showQuickCheckinInfo();
    }, 
    showQuickCheckinInfo() {
      debugger;
      this.pat = null;
      this.showDropDownModalInfo = true;
      this.showDropDownModal = false;
    },
    getPatientFromMain(pat) {
      this.pat = pat;
      this.showDropDownModalInfo = true;
      this.showDropDownModal = false;
    },
    hideQuickCheckinInfo() {
      this.showDropDownModalInfo = false;
      this.showDropDownModal = false;
    },

    newTab() {
      window.open(
        this.CHECKINSERVER + "/?index=" + this.value + "&area=" + this.Id1,
        "_blank"
      );
    },
    newTabClick() {
      debugger;
      this.showDropDownModal = true;
      this.$refs.quickCheckinMain.showThisModel = true;
    },
    dropdownModalClosed(val) {
      this.showDropDownModal = val;
    },
    HomeButton() {
      window.location.href = this.USERSSERVER + "/myLocations";
    },
    logoutClick() {
      this.intDummyComm();
      const url = this.SERVER + `/VNSPRAAPI/Practices/Logout`;
      axios({
        method: "post",
        url: url,
        data: this.dummyComm,
      }).then(() => {});

      localStorage.icore = "";
      location.href = this.USERSSERVER;
    },

    GetPracticeNameAddess() {
      const str = localStorage.OSversion;
      const arr = str.split("<VEINS2021/>");
      var OwnerId = arr[1];
      this.PracticeId = this.getLocalStoragexeon;
      this.ownerId = OwnerId;
      const url =
        this.SERVER +
        "/VNSPRAAPI/Practices/GetPractName?ownerid=" +
        this.ownerId +
        "&PracticeID=" +
        this.PracticeId +
        "";
      this.axiosGetPracticeNameAddress(url);
    },
    async axiosGetPracticeNameAddress(Url) {
      var loader = this.$loading.show({
        // Optional parameters
        color: "#03a9f3",
      });
      console.log(Url);
      await axios({
        method: "get",
        url: Url,
      })
        .then((res) => {
          loader.hide();
          const result = res.data;
          if (result.status) {
            var pract = result.data;

            this.Practice =
              pract.rtp +
              " - " +
              pract.name +
              " - " +
              pract.address +
              " - " +
              pract.phone;
            localStorage.setItem("PracticeName", pract.name);
            localStorage.setItem("PracticeAddress", pract.address);
            localStorage.setItem("RTPID", pract.rtp);
            localStorage.setItem(
              "UserName",
              pract.firstName + " " + pract.lastName
            );
            localStorage.setItem("Email", pract.email);
            console.log(pract);
          }
        })
        .catch(function(error) {
          alert(console.log(error));
        })
        .finally(() => {
          loader.hide();
        });
    },

    GetProfileInfo() {
      const str = localStorage.OSversion;
      const arr = str.split("<VEINS2021/>");
      var UserId = arr[0];
      this.UserId = UserId;
      const url =
        this.SERVER + "/VNSPRAAPI/Practices/GetProfile?UserId=" + UserId;
      this.axiosGetProfileData1(url);
    },
    async axiosGetProfileData1(Url) {
      var loader = this.$loading.show({
        // Optional parameters
        color: "#03a9f3",
      });
      console.log("GetData");
      await axios({
        method: "get",
        url: Url,
      })
        .then((res) => {
          loader.hide();
          const result = res.data;
          if (result.status) {
            //name changes
            this.profileInfo = result.data[0];
            this.profileInfo.confirmPassword = result.data[0].password;
            this.name =
              this.profileInfo.firstName + " " + this.profileInfo.lastName;
            var date = moment(String(result.data[0].dob)).format("YYYY-MM-DD");
            this.profileInfo.doBstr = date;
          }
        })
        .catch(function(error) {
          alert(console.log(error));
        })
        .finally(() => {
          loader.hide();
        });

      this.GetUserImage(this.UserId);
    },

    UpdateProfileInfo() {
      if (!this.profileInfo.firstName) {
        this.ShowWarning("First Name is required");
        return;
      } else if (!this.profileInfo.lastName) {
        this.ShowWarning("Last Name is required");
        return;
      } else if (!this.profileInfo.password) {
        this.ShowWarning("Password is required");
        return;
      } else if (!this.profileInfo.confirmPassword) {
        this.ShowWarning("Confirm Password is required");
        event.preventDefault();
        return;
      } else if (
        this.profileInfo.confirmPassword != this.profileInfo.password
      ) {
        this.ShowWarning("Password & ConfirmPassword must be same");
        event.preventDefault();
        return;
      } else if (!this.profileInfo.phone) {
        this.ShowWarning("Phone is required");
        event.preventDefault();
        return;
      }

      const url = this.SERVER + "/VNSPRAAPI/Practices/UpdateProfile";
      this.axiosUpdateProfileData1(url);
    },
    async axiosUpdateProfileData1(Url) {
      var loader = this.$loading.show({
        // Optional parameters
        color: "#03a9f3",
      });
      console.log("GetData");
      await axios({
        method: "post",
        data: this.profileInfo,
        url: Url,
      })
        .then((res) => {
          loader.hide();
          const result = res.data;
          if (result.status) {
            $("#myProfile").modal("hide");
            this.GetProfileInfo();
            this.successToastUpd();
          } else if (result.message == "Invalid Date of Birth!") {
            this.ShowWarning(result.message);
          }
        })
        .catch(function(error) {
          alert(console.log(error));
        })
        .finally(() => {
          loader.hide();
        });
    },
    ViewAllLocationClick() {
      var loader = this.$loading.show({
        // Optional parameters
        color: "#03a9f3",
      });
      window.location.href = this.USERSSERVER + "/myLocations";
      loader.hide();
    },
    GetUserNotifications1(ownerId) {
      const url =
        this.SERVER + "/VNSPRAAPI/Practices/GetNotifiH?ownerId=" + ownerId;
      //this.axiosGetProfileData12(url, 1);
    },
    async axiosGetProfileData12(Url, what) {
      var loader = this.$loading.show({
        // Optional parameters
        color: "#03a9f3",
      });
      console.log(what);
      await axios({
        method: "get",
        url: Url,
      })
        .then((res) => {
          loader.hide();
          const result = res.data;
          if (result.status) {
            this.notification1 = result.data;
            this.seenCount1 = this.notification1.filter(
              (notification1) => notification1.seen == false
            ).length;
            if (this.seenCount1 > 0) {
              this.showNotify = 1;
            } else {
              this.showNotify = 0;
            }
          } else {
            this.notification1 = [];
            this.seenCount = 0;
          }
        })
        .catch(function(error) {
          alert(console.log(error));
        })
        .finally(() => {
          loader.hide();
        });
    },

    setName(userId, ownerId) {
      this.gUserId = ownerId;
      var url =
        this.SERVER +
        "/VNSPRAAPI/Patient/GetOwnerByUsers?UserId=" +
        this.gUserId;
      this.axiosGetUserNameData(url, userId, ownerId);
    },
    async axiosGetUserNameData(Url, userId, ownerId) {
      console.log("GetData");
      await axios({
        method: "post",
        url: Url,
      })
        .then((res) => {
          if (userId == ownerId) {
            this.UserD_name = res.data.firstName;
            this.isemployee = false;
          } else {
            this.UserD_name = res.data.firstName;
            this.isemployee = true;
          }
        })
        .catch(function(error) {
          alert(error);
        })
        .finally(() => {});
    },

    GetUserNotifications() {
      const str = localStorage.OSversion;
      const arr = str.split("<VEINS2021/>");
      var OwnerId = arr[1];
      const url =
        this.SERVER + "/VNSPRAAPI/Practices/GetNotifiH?ownerId=" + OwnerId;
      this.$refs.auditLogComponent.loadInitNotification();
      //this.axiosGetProfileData11(url, 1);
    },
    async axiosGetProfileData11(Url) {
      // var loader = this.$loading.show({
      //     // Optional parameters
      //       color: '#03a9f3'
      //     });
      console.log("GetData");
      await axios({
        method: "get",
        url: Url,
      })
        .then((res) => {
          // loader.hide();
          const result = res.data;
          if (result.status) {
            this.notification = result.data;
            this.seenCount = this.notification.filter(
              (notification) => notification.seen == false
            ).length;
          } else {
            this.notification = [];
            this.seenCount = 0;
          }
        })
        .catch(function(error) {
          alert(console.log(error));
        })
        .finally(() => {
          //loader.hide();
        });

      this.GetUserNotificatnImage();
    },

    ShowNotification() {
      this.$router.push({ path: "/auditLog" });
    },

    GetUserNotificatnImage() {
      const url =
        this.SERVER +
        "/VNSPRAAPI/Practices/GetUserProfilePics?UserProfileId=" +
        this.UserId;
      this.axiosGetUserData123(url, 1);
    },
    async axiosGetUserData123(Url) {
      // var loader = this.$loading.show({
      //     // Optional parameters
      //       color: '#03a9f3'
      //     });
      console.log("GetData");
      await axios({
        method: "get",
        url: Url,
      })
        .then((res) => {
          //loader.hide();
          this.Image1 = res.data;
        })
        .catch(function(error) {
          alert(console.log(error));
        })
        .finally(() => {
          //loader.hide();
        });
    },

    //For Image
    GetUserImage(UserId) {
      const url =
        this.SERVER +
        "/VNSPRAAPI/Practices/GetUserProfilePics?UserProfileId=" +
        UserId;
      this.axiosGetUserData11(url);
    },
    async axiosGetUserData11(Url) {
      console.log("GetData");
      await axios({
        method: "get",
        url: Url,
      })
        .then((res) => {
          this.Image = res.data;
          this.$forceUpdate();
        })
        .catch(function(error) {
          alert(console.log(error));
        })
        .finally(() => {});
    },

    GetUserPractice() {
      const url =
        `${this.SERVER}/VNSPRAAPI/Practices/GetPractsHead?page=` +
        1 +
        "&ownerId=" +
        this.ownerId;
      this.axiosGetPractices(url, 1);
    },
    async axiosGetPractices(Url) {
      var loader = this.$loading.show({
        // Optional parameters
        color: "#03a9f3",
      });
      console.log("GetData Practice Header");
      await axios({
        method: "get",
        url: Url,
      })
        .then((res) => {
          loader.hide();
          const result = res.data;
          if (result.status) {
            this.Practices = result.data;
            this.showNotify1 = 0;
          } else {
            this.location = {};
          }
        })
        .catch(function(error) {
          alert(console.log(error));
        })
        .finally(() => {
          loader.hide();
        });
    },
    goButtonClick(id) {
      var loader = this.$loading.show({
        // Optional parameters
        color: "#03a9f3",
      });
      //alert(id);
      localStorage.xeon = id; //id;
      //alert('http://localhost:8081/?index=' + this.dummyComm.auditFlagVal + '&area=' + id);
      window.location.href =
        this.PRACTICESERVER +
        "/?index=" +
        localStorage.OSversion +
        "&area=" +
        id;
      loader.hide();
    },
    lockScreen() {
      // var loader = this.$loading.show({
      //   // Optional parameters
      //   color: "#03a9f3",
      // });
      localStorage.icore = "lockscreen";
      location.reload();
      //loader.hide();
    }, // end methods
  },
  mounted() {
    this.$refs.auditLogComponent.loadInitNotification();
    if (this.geterLocalStorage) {
      if (localStorage.OSversion == undefined) {
        localStorage.OSversion = this.geterLocalStorage;
        localStorage.xeon = this.getLocalStoragexeon;
      }
      //localStorage.xeon = this.getLocalStoragexeon;
      const str = localStorage.OSversion;
      const arr = str.split(this.UKEY);

      this.GetPracticeNameAddess();
      this.GetProfileInfo();
      this.GetUserPractice();
      this.GetUserNotifications1(arr[1]);
      this.setName(arr[0], arr[1]);
    }
  },
  created() {},
  watch: {
    ProfileImage: function() {
      this.Image = this.Image12.data;
    },

    Image12: function() {
      this.Image = "";
      this.Image = this.Image12.data;
    },
  },
};
</script>

<style scoped>
.topbar .top-navbar .mailbox {
  width: 600px !important;
}
#ablack:hover {
  color: black;
}
.form-floating-label {
  position: relative;
}

.form-floating-label [type="text"],
.form-floating-label [type="password"],
.form-floating-label [type="date"],
.form-floating-label [type="datetime"],
.form-floating-label [type="datetime-local"],
.form-floating-label [type="month"],
.form-floating-label [type="week"],
.form-floating-label [type="email"],
.form-floating-label [type="number"],
.form-floating-label [type="search"],
.form-floating-label [type="tel"],
.form-floating-label [type="time"],
.form-floating-label [type="url"],
.form-floating-label [type="color"],
.form-floating-label textarea {
  margin-bottom: 0;
  color: black;
  /*            color:#8a8a8a ;
    */
  font-size: 15px;
  font-weight: 300;
  padding: 38px 1rem 1rem 2px;
}

.dummy-label {
  margin-top: -7px;
  margin-bottom: 0;
  color: black;
  font-size: 16px;
}

.form-floating-label label {
  color: black;
  font-size: 14px;
  position: absolute;
  pointer-events: none;
  left: 2px;
  bottom: 0;
  transition: all 0.2s ease-in;
  font-weight: bold;
}

.form-floating-label textarea ~ label {
  top: 20px;
  font-size: 18px;
  font-weight: 300;
}

.form-floating-label input:focus ~ label,
.form-floating-label input:disabled[value] ~ label,
.form-floating-label.has-value input ~ label {
  top: 0;
  font-size: 13px;
  color: black;
  font-weight: bold !important;
  font-weight: 400;
}

.form-floating-label textarea:focus ~ label,
.form-floating-label.has-value textarea ~ label {
  top: 0;
  font-size: 13px;
  color: dodgerblue;
  font-weight: 400;
}
#notify1 {
  margin-left: 65px;
  position: absolute;
  margin-top: -47px;
}
#notify2 {
  margin-left: 65px;
  position: absolute;
  margin-top: -29px;
}
.backgroundgray {
  background: gray;
}
</style>
